export default __webpack_public_path__ + "static/media/splashscreen.6fbcf603.png";